import useHighlightOnHover from '#app/utils/hooks/useHighlightOnHover'
import { cn } from '#app/utils/misc'
import {
	DropdownMenuItem,
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuTrigger,
	DropdownMenuPortal,
} from './dropdown-menu'
import { Icon } from './icon'

export default function ActionMenu({
	menuItemContents,
	triggerClassName,
    contentClassName,
}: {
	menuItemContents: React.ReactNode[]
	triggerClassName?: string
    contentClassName?: string
}) {
	const [hoverRef, isHovered] = useHighlightOnHover()

	return (
		<DropdownMenu>
			<DropdownMenuTrigger className={cn('h-fit', triggerClassName)}>
				<div
					ref={hoverRef}
					className={cn('px-2 pb-1', isHovered && 'rounded-2xl bg-slate-100')}
				>
					<Icon name="dots-vertical" size="sm" />
				</div>
			</DropdownMenuTrigger>
			<DropdownMenuPortal>
				<DropdownMenuContent align="start" className={contentClassName}>
					{menuItemContents.map((menuItemContent, index) => (
						<DropdownMenuItem asChild key={index}>
							{menuItemContent}
						</DropdownMenuItem>
					))}
				</DropdownMenuContent>
			</DropdownMenuPortal>
		</DropdownMenu>
	)
}
